"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var inline_icon_1 = tslib_1.__importDefault(require("../../../../../ui-components/inline-icon/inline-icon"));
var LinkCopiedIcon_1 = tslib_1.__importDefault(require("../../../../../../icons/compiled/components/LinkCopiedIcon"));
var styles_scss_1 = tslib_1.__importDefault(require("./styles.scss"));
var LinkCopied = function (_a) {
    var _b, _c;
    var dataHook = _a.dataHook, shouldShowLink = _a.shouldShowLink, text = _a.text, isRTL = _a.isRTL;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_scss_1.default['link-container'], (_b = {},
            _b[styles_scss_1.default['link-fade-in']] = shouldShowLink,
            _b)), "aria-hidden": "true", tabIndex: "-1", "data-hook": dataHook },
        react_1.default.createElement(inline_icon_1.default, { className: (0, classnames_1.default)(styles_scss_1.default.icon, (_c = {},
                _c[styles_scss_1.default.rtl] = isRTL,
                _c[styles_scss_1.default.ltr] = !isRTL,
                _c)), icon: react_1.default.createElement(LinkCopiedIcon_1.default, null) }),
        react_1.default.createElement("div", { "data-hook": "link-copied-text" }, text)));
};
LinkCopied.propTypes = {
    dataHook: prop_types_1.default.string,
    shouldShowLink: prop_types_1.default.bool,
    text: prop_types_1.default.string,
    isRTL: prop_types_1.default.bool,
};
exports.default = LinkCopied;
//# sourceMappingURL=link-copied.js.map